import React, { useState, useEffect } from 'react';

const MidnightClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  const hours = time.getHours();
  const minutes = time.getMinutes().toString().padStart(2, '0');
  const seconds = time.getSeconds();
  
  let displayHour = hours % 12;
  if (displayHour === 0) displayHour = 12;
  
  let period = 'AM';
  if (displayHour >= 7 && displayHour <= 11) {
    period = 'PM';
  }

  return (
    <div className="flex flex-col items-end space-y-1 pointer-events-auto">
      {/* 提高亮度的 amber-400 */}
      <div className="flex items-center text-amber-400 font-light tracking-widest text-sm drop-shadow-[0_0_8px_rgba(251,191,36,0.5)]">
        <span>{displayHour.toString().padStart(2, '0')}</span>
        <span className="mx-1 transition-opacity duration-500" style={{ opacity: seconds % 2 === 0 ? 1 : 0.2 }}>:</span>
        <span>{minutes}</span>
        <span className="ml-2 text-[10px] text-amber-400/80">{period}</span>
      </div>
      <span className="text-[7px] tracking-[0.4em] text-gray-500 uppercase">Real Time synced</span>
    </div>
  );
};

export default MidnightClock;